import { X, Download, FileText } from "lucide-react";
import debitNoteService from "../services/debitNoteService";
import Swal from "sweetalert2";

export default function DebitNoteDetailModal({ debitNote, onClose, onDownloadPdf }) {
  const handleDownloadJson = async () => {
    try {
      await debitNoteService.downloadJson(debitNote.id, debitNote.numero_control);
    } catch (error) {
      Swal.fire("Error", "No se pudo descargar el JSON", "error");
    }
  };

  const handleDownloadJsonFirmado = async () => {
    try {
      await debitNoteService.downloadJsonFirmado(debitNote.id, debitNote.numero_control);
    } catch (error) {
      Swal.fire("Error", "No se pudo descargar el JSON firmado", "error");
    }
  };

  return (
    <>
      <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content card" style={{ maxHeight: "90vh" }}>
            <div className="card-header">
              <h3 className="card-title" style={{ margin: 0 }}>📄 Detalle de Nota de Débito</h3>
              <button className="btn btn-secondary btn-sm" onClick={onClose}>
                <X size={18} />
              </button>
            </div>

            <div className="card-body" style={{ overflowY: "auto" }}>
              <div style={{ padding: "16px", background: "#f7fafc", borderRadius: "10px", border: "2px solid #e2e8f0", marginBottom: "16px" }}>
                <div style={{ marginBottom: "12px" }}>
                  <label style={{ fontSize: "13px", color: "#6b7280", display: "block" }}>Número de Control</label>
                  <div style={{ fontSize: "14px", fontWeight: 600 }}>{debitNote.numero_control}</div>
                </div>
                <div style={{ marginBottom: "12px" }}>
                  <label style={{ fontSize: "13px", color: "#6b7280", display: "block" }}>Código de Generación</label>
                  <div style={{ fontSize: "12px", fontWeight: 600, color: "#2563eb", wordBreak: "break-all" }}>{debitNote.codigo_generacion}</div>
                </div>
                <div style={{ marginBottom: "12px" }}>
                  <label style={{ fontSize: "13px", color: "#6b7280", display: "block" }}>Cliente</label>
                  <div style={{ fontSize: "14px", fontWeight: 600 }}>{debitNote.sale?.client?.nombre || "N/A"}</div>
                </div>
                <div style={{ marginBottom: "12px" }}>
                  <label style={{ fontSize: "13px", color: "#6b7280", display: "block" }}>Fecha de Emisión</label>
                  <div style={{ fontSize: "14px" }}>{new Date(debitNote.fecha_emision).toLocaleDateString("es-SV")}</div>
                </div>
                <div>
                  <label style={{ fontSize: "13px", color: "#6b7280", display: "block" }}>Estado DTE</label>
                  <span style={{ padding: "4px 12px", background: debitNote.estado_dte === "VALIDADO" ? "#d1fae5" : "#fee2e2", color: debitNote.estado_dte === "VALIDADO" ? "#065f46" : "#991b1b", borderRadius: "6px", fontSize: "12px", fontWeight: 600 }}>
                    {debitNote.estado_dte}
                  </span>
                </div>
              </div>

              <div style={{ padding: "16px", background: "#eff6ff", borderRadius: "10px", border: "2px solid #bfdbfe", marginBottom: "16px" }}>
                <h4 style={{ fontSize: "16px", marginBottom: "8px", color: "#1e40af" }}>📝 Motivo</h4>
                <div style={{ fontSize: "14px", color: "#1e3a8a" }}>{debitNote.motivo}</div>
              </div>

              <div style={{ padding: "20px", background: "linear-gradient(135deg, #2563eb 0%, #1e40af 100%)", borderRadius: "10px", color: "#fff" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ fontSize: "18px", fontWeight: 600 }}>Monto Aumentado</div>
                  <div style={{ fontSize: "32px", fontWeight: 700 }}>${Number(debitNote.amount).toFixed(2)}</div>
                </div>
              </div>

              <div style={{ marginTop: "24px" }}>
                <h4 style={{ fontSize: "16px", marginBottom: "12px" }}>📥 Descargas</h4>
                <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
                  <button className="btn btn-success" onClick={() => onDownloadPdf(debitNote)}>
                    <Download size={16} /> Descargar PDF
                  </button>
                  <button className="btn btn-primary" onClick={handleDownloadJson}>
                    <FileText size={16} /> Descargar JSON
                  </button>
                  {debitNote.json_firmado_path && (
                    <button className="btn btn-primary" onClick={handleDownloadJsonFirmado}>
                      <FileText size={16} /> Descargar JSON Firmado
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div className="card-body" style={{ borderTop: "2px solid #e2e8f0", display: "flex", justifyContent: "flex-end", paddingTop: "var(--spacing-md)" }}>
              <button className="btn btn-secondary" onClick={onClose}>Cerrar</button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}